import * as Popper from '@popperjs/core';

export function initHighlightEditors() {
    const bannerPoints = document.querySelectorAll<HTMLDivElement>('.bannerPoint');
    const closeButtons = document.querySelectorAll<HTMLButtonElement>('.js-close-highlight-point');

    function hideAllBannerPoints() {
        bannerPoints.forEach((bannerPoint) => {
            bannerPoint.classList.remove("active");
            const id=bannerPoint.querySelector<HTMLDivElement>(".bannerPoint__button").getAttribute("data-target");
            document.getElementById(id).classList.remove("active");
        });
    }

    bannerPoints.forEach(bannerPoint => {
        const bannerPointButton = bannerPoint.querySelector<HTMLDivElement>(".bannerPoint__button");
        const id=bannerPointButton.getAttribute("data-target");
        const bannerPointContent = document.getElementById<HTMLDivElement>(id);
        const position = bannerPoint.classList.contains("bannerPoint--left") ? "top-start" : "top-end";
        // Check if the parent has a swiper-slide ancestor
        const swiperSlideAncestor = bannerPoint.closest('.swiper-slide');
        const boundary = swiperSlideAncestor || 'document'; // Default to 'document' if no swiper-slide ancestor
        const popperInstance = Popper.createPopper(bannerPointButton, bannerPointContent, {
            boundary: 'document',
            placement: position,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [9, 9],
                    },
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top', 'bottom'],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'document',

//                        boundary: boundary, // Use the swiper-slide ancestor or 'document'
                    },
                },
            ],
        });
        bannerPointButton.addEventListener('click', () => {
            const isVisible = bannerPoint.classList.contains('active');
            if (isVisible) {
                bannerPoint.classList.remove("active");
                bannerPointContent.classList.remove("active");
            } else {
                hideAllBannerPoints();
                bannerPoint.classList.add("active");
                bannerPointContent.classList.add("active");
                popperInstance.update();
            }
        });
    });
    closeButtons.forEach((closeButton) => {
        closeButton.addEventListener("click", hideAllBannerPoints);
    })
    document.addEventListener('click', (evt) => {
        const bannerButton = evt.target.closest('.bannerPoint__content, .bannerPoint__button');
        if (!bannerButton) {
            hideAllBannerPoints();
        }
    });

}


